import React, { useEffect, useState } from "react";

const AnalogWallClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();

  const secondDeg = seconds * 6;
  const minuteDeg = minutes * 6 + seconds * 0.1;
  const hourDeg = (hours % 12) * 30 + minutes * 0.5;

  // Numbers 1 to 12
  const numbers = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  return (

    <div style={styles.clock}>
      {/* Numbers */}
      {numbers.map((num, index) => {
        const angle = (index * 30) - 90; // Adjust positioning
        const radius = 42; // Distance from center

        const x = radius * Math.cos((angle * Math.PI) / 180);
        const y = radius * Math.sin((angle * Math.PI) / 180);

        return (
          <div
            key={index}
            style={{
              ...styles.number,
              left: `calc(50% + ${x}px)`,
              top: `calc(50% + ${y}px)`,
            }}
          >
            {num}
          </div>
        );
      })}

      {/* Hour Hand */}
      <div
        style={{
          ...styles.hand,
          ...styles.hourHand,
          transform: `translateX(-50%) rotate(${hourDeg}deg)`
        }}
      />

      {/* Minute Hand */}
      <div
        style={{
          ...styles.hand,
          ...styles.minuteHand,
          transform: `translateX(-50%) rotate(${minuteDeg}deg)`
        }}
      />

      {/* Second Hand */}
      <div
        style={{
          ...styles.hand,
          ...styles.secondHand,
          transform: `translateX(-50%) rotate(${secondDeg}deg)`
        }}
      />

      {/* Center Dot */}
      <div style={styles.centerDot} />

 

    </div>



  );
};


const styles = {
  clock: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    border: "6px solid #7b5cbd",
    position: "relative",
    background: "white",
    boxShadow: "0px 0px 12px rgba(0,0,0,0.1)",
  },

  number: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    fontSize: "12px",
    fontWeight: "700",
    color: "#333",
    pointerEvents: "none",
  },

  hand: {
    position: "absolute",
    left: "50%",
    bottom: "50%",
    transformOrigin: "bottom",
    borderRadius: "8px",
  },

  hourHand: {
    width: "6px",
    height: "35px",
    background: "#7b5cbd",
  },

  minuteHand: {
    width: "4px",
    height: "45px",
    background: "#555",
  },

  secondHand: {
    width: "2px",
    height: "50px",
    background: "red",
  },

  centerDot: {
    width: "10px",
    height: "10px",
    background: "#7b5cbd",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export default React.memo(AnalogWallClock);
